class LISSIntegration {
    id: number;
    campusID: number;
    termDatesID: number;
    schoolID: number;

    createdBy: number;
    createdOn: Date;
    editedBy: number;
    editedOn: Date;
    recycledBy?: number;
    recycledOn?: Date;

    schema: string;
    providerUrl: string;
    userAgent: string;
    userName: string;
    password: string;
    schoolName: string;

    syncType: string;
    syncAtTime: string;
    syncFailed: number;

    tT_FileID: number;
    tT_StartDate: Date;
    tT_EndDate: Date;
    ttStructure: string;
    targetSyncDate: Date;

    dO_Horizon: number;
    dO_PastHorizon: number;

    compass_StartDate?: Date;
    compass_EndDate?: Date;

    active: boolean;
    lastSync: Date;

    immediateSync: boolean;
    runValidation: boolean;

    get type(): string {
        return "LISS";
    }

    get descriptor(): string {
        return `${this.type} Provider - ${this.schoolName || this.providerUrl}`;
    }

    get user(): string {
        return this.userName;
    }

    get providerURL(): string {
        return this.providerUrl;
    }

    get tT_Horizon(): number {
        return (
            (this.tT_EndDate.getTime() - this.tT_StartDate.getTime()) /
            (1000 * 60 * 60 * 24)
        );
    }
    set tT_Horizon(value: number) {
        this.tT_EndDate = new Date(
            this.tT_StartDate.getTime() + value * 1000 * 60 * 60 * 24,
        );
    }

    constructor(data?: Partial<LISSIntegration>) {
        Object.assign(this, data);

        this.providerUrl = this.providerUrl ?? "";
        this.active = this.active ?? false;
        this.dO_Horizon = this.dO_Horizon ?? 0;
        this.dO_PastHorizon = this.dO_PastHorizon ?? 0;

        if (typeof this.createdOn === "string")
            this.createdOn = new Date(this.createdOn);

        if (typeof this.editedOn === "string")
            this.editedOn = new Date(this.editedOn);

        if (typeof this.recycledOn === "string")
            this.recycledOn = new Date(this.recycledOn);

        if (typeof this.tT_StartDate === "string")
            this.tT_StartDate = new Date(this.tT_StartDate);

        if (typeof this.tT_EndDate === "string")
            this.tT_EndDate = new Date(this.tT_EndDate);

        if (typeof this.compass_StartDate === "string")
            this.compass_StartDate = new Date(this.compass_StartDate);

        if (typeof this.compass_EndDate === "string")
            this.compass_EndDate = new Date(this.compass_EndDate);

        if (typeof this.lastSync === "string")
            this.lastSync = new Date(this.lastSync);

        if (typeof this.targetSyncDate === "string")
            this.targetSyncDate = new Date(this.targetSyncDate);

        this.tT_StartDate = this.tT_StartDate ?? new Date();
        this.tT_EndDate = this.tT_EndDate ?? new Date();

        this.schema = this.schema ?? "";

        this.syncType = this.active ? "TIME" : "MANUAL";
    }

    clone() {
        return new LISSIntegration(structuredClone(this));
    }
}

export default LISSIntegration;
